const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const GameMatchAdd = () => import(/* webpackChunkName: "game" */ '@/modules/game/match/view/add.vue');
const GameMatchDetail = () => import(/* webpackChunkName: "game" */ '@/modules/game/match/view/detail.vue');
const GameMatchEdit = () => import(/* webpackChunkName: "game" */ '@/modules/game/match/view/edit.vue');
const GameMatchList = () => import(/* webpackChunkName: "game" */ '@/modules/game/match/view/index.vue');
const GameVariantAdd = () => import(/* webpackChunkName: "game" */ '@/modules/game/variant/view/add.vue');
const GameVariantList = () => import(/* webpackChunkName: "game" */ '@/modules/game/variant/view/index.vue');
const GameVariantTranslate = () => import(/* webpackChunkName:"game" */ '@/modules/game/variant/view/translate.vue');
const GameParameter = () => import(/* webpackChunkName: "game" */ '@/modules/game/parameter/view/edit.vue');
const GameReport = () => import(/* webpackChunkName: "game" */ '@/modules/game/report/view/edit.vue');

export const ROUTE_NAME_GAME = {
    MATCH: {
        ADD: 'GameMatchAdd',
        DETAIL: 'GameMatchDetail',
        EDIT: 'GameMatchEdit',
        INDEX: 'GameMatchList'
    },
    VARIANT: {
        ADD: 'GameVariantAdd',
        INDEX: 'GameVariantList',
        TRANSLATE: 'GameVariantTranslate'
    },
    PARAMETER: 'GameParameter',
    REPORT: 'GameReport'
} as const;

export default [
    {
        path: '/app/:appId/game/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'report',
                name: ROUTE_NAME_GAME.REPORT,
                component: GameReport,
                meta: { requiresAuth: true }
            },
            {
                path: 'parameter',
                name: ROUTE_NAME_GAME.PARAMETER,
                component: GameParameter,
                meta: { requiresAuth: true }
            },
            {
                path: 'variant',
                name: 'Variant',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_GAME.VARIANT.INDEX,
                        component: GameVariantList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_GAME.VARIANT.ADD,
                        component: GameVariantAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_GAME.VARIANT.TRANSLATE,
                        component: GameVariantTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'match',
                name: 'Match',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_GAME.MATCH.INDEX,
                        component: GameMatchList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_GAME.MATCH.ADD,
                        component: GameMatchAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_GAME.MATCH.EDIT,
                        component: GameMatchEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_GAME.MATCH.DETAIL,
                        component: GameMatchDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
